import { makeStyles, Theme } from '@material-ui/core';

export const useTransactionDetailStyles = makeStyles<Theme>((theme) => ({
  itemWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  itemTitle: {
    color: 'rgba(171, 171, 171, 1)',
    fontSize: 14,
  },
  itemContent: {
    color: 'rgba(250, 250, 250, 1)',
    fontSize: 14,
    fontWeight: 400,
  },
}));
